import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { setPermanentSession } from "modules/Login/hooks";
import { ApiInstance } from "utils/Api";

import type { DefaultError } from "@tanstack/react-query";
import type { Session } from "modules/Login/queryKeys";

type SignInPayload = {
  id_token: string;
};

export const useGoogleLoginMutation = (onLoginError: (error: DefaultError) => void) =>
  useTypedMutation<SignInPayload, Session>({
    mutationFn: async payload => (await ApiInstance.post("/session/login/google_sign_in", payload, ENV.authBaseURL)).data,
    onSuccess: (_, session) => setPermanentSession(session),
    onError: onLoginError
  });
